import React, { useLayoutEffect, useState } from "react";
import styles from "./Textarea.module.scss";
import isSafari from "../../util/isSafari";
import { twMerge } from "tailwind-merge";
import { useSyncRefs } from "../../hooks";
const Textarea = React.forwardRef(({ className, textareaClassName, isError, errorText = "", value, autoExpandable, dataCySuffix, maxLength, ...rest }, outerRef) => {
    const _isError = isError || errorText;
    const [componentRef, setComponentRef] = useState(null);
    const ref = useSyncRefs(setComponentRef, outerRef);
    useLayoutEffect(() => {
        autoExpandable && handleTextareaInputHeight();
    });
    const handleTextareaInputHeight = () => {
        const textarea = componentRef;
        if (textarea) {
            textarea.style.height = "auto";
            const computedStyle = getComputedStyle(textarea);
            const paddingBottom = parseFloat(computedStyle.paddingBottom || "0");
            textarea.style.height = `${textarea.scrollHeight - paddingBottom + 2}px`;
        }
    };
    const dataCy = (name) => {
        return dataCySuffix ? `${name}-${dataCySuffix}` : name;
    };
    const dataCyProps = {
        root: dataCy("ukt-textarea"),
        input: dataCy("ukt-textarea-input"),
    };
    return (React.createElement("div", { "data-cy": dataCyProps.root, className: twMerge("ukt-textarea", styles.textarea, _isError && styles.error, className, "relative") },
        React.createElement("textarea", { ref: ref, ...rest, value: value, "data-cy": dataCyProps.input, maxLength: maxLength, onChange: (e) => {
                rest.onChange(e);
            }, className: twMerge(isSafari() && "!outline-none", "typography-main shadow-input_inner", autoExpandable && "resize-none overflow-hidden", maxLength ? "!pb-[25px]" : "", textareaClassName) }),
        _isError && React.createElement("span", { className: "typography-small" }, errorText)));
});
export default Textarea;
//# sourceMappingURL=Textarea.js.map